export function getDisplayNumber(n: number) {
    return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function getSign(n: number): string {
    return n >= 0 ? '+' : ''; // '-' will be added to the number itself already
}
